// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"883":"49e33c3e","4485":"adc0efc9"}[chunkId] + ".chunk.css";
};